import { instance } from ".";
import axios from "axios";

export const getInventTypesList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/dict/resource-type"
  });
  return response;
};

export const getInventType = id => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/resource-type/${id}`
  });
  return response;
};

export const createInventType = (data) => {
  const response = instance({
    method: "post",
    url: `/work/api/dict/resource-type`,
    headers: {
      'Accept': 'application/json'
    },
    data
  });
  return response;
}

export const deleteInventType = id => {
  const response = instance({
    method: "delete",
    url: `/work/api/dict/resource-type/${id}`
  });
  return response;
};

export const updateInventType = (id, main) => {
  const data = {
    main: {
      ...main,
    }
  }

  const response = instance({
    method: "put",
    url: `/work/api/dict/resource-type/${id}`,
    data
  });
  return response;
};

export default {
  getInventTypesList,
  getInventType,
  createInventType,
  deleteInventType,
  updateInventType
};
